import React from 'react';

export function ScoreGauge({ score, size = 'md' }) {
  const num = parseFloat(score);
  const risk = num > 7 ? 'vert' : num >= 4 ? 'orange' : 'rouge';
  const cls = size === 'lg' ? 'score-gauge-lg' : 'score-gauge';

  if (size === 'lg') {
    return (
      <div className={`${cls} ${risk}`}>
        <div className="score-value">{num ? num.toFixed(1) : 'N/A'}</div>
        <div className="score-label">/ 10</div>
      </div>
    );
  }

  return (
    <div className={`${cls} ${risk}`}>
      {num ? num.toFixed(1) : 'N/A'}
    </div>
  );
}

export function RiskBadge({ level }) {
  const labels = { vert: 'Résilient', orange: 'Vigilance', rouge: 'Critique' };
  return <span className={`badge badge-${level}`}>{labels[level] || level}</span>;
}

export function ScoreCell({ score }) {
  const num = parseFloat(score);
  if (!num && num !== 0) return <td className="score-cell">-</td>;
  const color = num > 7 ? '#27AE60' : num >= 4 ? '#F39C12' : '#E74C3C';
  return (
    <td className="score-cell" style={{ color, background: `${color}15` }}>
      {num.toFixed(1)}
    </td>
  );
}
